export enum PlansRoutes {
  root = 'plans',
  main = '',
  requested = 'requested',
  list = 'list',
  items = 'items',
  plan = 'plan',
  preview = 'preview',
}
